import{i}from"./chunk-OWVDW4YO.js";import{m as e}from"./chunk-HBP5N4FR.js";e();i();var r=()=>{var t;let{hash:o}=window.location;return(t=o.split("/")[2])!=null?t:"raw"};export{r as a};
//# sourceMappingURL=chunk-WMRHZ47G.js.map
